var React = require('react');

function CarrotMD (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15 11.3334L27 0L30 2.83333L15 17L0 2.83337L3 3.48695e-05L15 11.3334Z","fill":"white"}));
}

CarrotMD.defaultProps = {"width":"30","height":"17","viewBox":"0 0 30 17","fill":"none"};

module.exports = CarrotMD;

CarrotMD.default = CarrotMD;
